import { render, staticRenderFns } from "./ChecklistDictionaryEdit.vue?vue&type=template&id=08199b26&"
import script from "./ChecklistDictionaryEdit.vue?vue&type=script&lang=js&"
export * from "./ChecklistDictionaryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports